import React, {createContext, FC, ReactNode, useContext} from "react";
import usePersistState from "../../hooks/usePresistState.tsx";

interface AuthOTPContextType {
    email: string;
    setEmailOtp: (email: string) => void;
}

const AuthOTPContext = createContext<AuthOTPContextType | undefined>(undefined);

const AuthOTPProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [email, setEmail] = usePersistState<string>("", "auth-otp-email");

    const setEmailOtp = (email: string) => {
        setEmail(email);
    }


    // Provide the authentication context to the children components
    return (
        <AuthOTPContext.Provider
            value={{
                email,
                setEmailOtp,
            }}
        >
            {children}
        </AuthOTPContext.Provider>
    );
};

export const useAuthOTP = (): AuthOTPContextType => {
    const context = useContext(AuthOTPContext);
    if (!context) {
        throw new Error("useAuthOTP must be used within an AuthOTPProvider");
    }
    return context;
};

export default AuthOTPProvider;
